(function($) {

    var basket = $('body .shopping-basket');



    function showBasket() {

        if(!basket.hasClass('display-basket')) {
            basket.addClass('display-basket');

            setTimeout(
                function () {
                    basket.removeClass('display-basket');
                }, 5000);
        }
    }



    $('.ajax_add_to_cart').click(function() {

        setTimeout(
            function() {
                var data = {
                    'action': 'update_cart_in_nav',
                    'dataType': 'json'
                };

                $.get(eventsFilter.ajaxurl, data, function (response) {
                    $('#display_basket_nav').html(response);
                    $('#basket_wrapper').css('display', 'block');
                });


                var data2 = {
                    'action': 'update_cart_in_nav_item',
                    'dataType': 'json'
                };

                $.get(eventsFilter.ajaxurl, data2, function (response) {

                    $('#cart_amount').html(response);

                    showBasket();
                });
            }, 1500);
    });

})(jQuery);
